export const categories = ["مواد خام", "مواد تعبئة", "منتج نهائي", "قطع غيار"];
export const units = ["كيلو", "طن", "حبة", "متر"];

export const initialWarehouses = [
  { id: "w1", name: "مخزن المواد الخام الرئيسي" },
  { id: "w2", name: "صالة الإنتاج (WIP)" },
  { id: "w3", name: "مخزن المنتج النهائي" }
];

export const initialProducts = [
  { id: 1, name: "PVC Resin K-67", category: "مواد خام", unit: "طن", minLimit: 5 },
  { id: 2, name: "كربونات كالسيوم", category: "مواد خام", unit: "طن", minLimit: 10 },
  { id: 3, name: "مثبت حراري (Stabilizer)", category: "مواد خام", unit: "كيلو", minLimit: 100 },
  { id: 4, name: "ماسورة PVC 4 بوصة", category: "منتج نهائي", unit: "حبة", minLimit: 200 }
];
